import { v4 as uuidv4 } from 'uuid'

/**
 * Handles interacting with device IDs
 */
class Device {
  /**
   * Set a storage bucket for the device id.
   */
  constructor(storage) {
    this.storage = storage
  }

  /**
   * Checks for a device ID. generates and stores one if not found
   */
  checkDeviceID() {
    this.deviceID = this.storage.getItem('onxDeviceID')

    if (!this.deviceID) {
      this.deviceID = this.generateDeviceID()
      this.storeDeviceID(this.deviceID)
    }
  }

  /**
   * Generates a device ID
   *
   * @return {string} - the generated device ID
   */
  generateDeviceID() {
    return uuidv4()
  }

  /**
   * Stores a device ID
   *
   * @param {string} deviceID - a uuidv4 that will be stored
   */
  storeDeviceID(deviceID) {
    this.storage.setItem('onxDeviceID', deviceID)
  }

  /**
   * Returns a device ID and generates one if needed
   *
   * @returns {string}
   */
  getDeviceID() {
    this.checkDeviceID()
    return this.deviceID
  }
}

let storage
try {
  storage = localStorage
} catch (ReferenceError) {
  storage = {}
}

const device = new Device(storage)
export default device
